<div class="d-flex flex-column position-relative">
    <button
        mat-icon-button
        mat-dialog-close
        aria-label="Close AWB subscribtion"
        class="position-absolute end-0 top-0 p-0 aling-center"
    >
        <mat-icon>close</mat-icon>
    </button>

    <div class="d-flex align-items-center justify-content-center mt-4 flex-column">
        <app-facility-logo class="mx-auto mt-3" [width]="'140'" [height]="'102'" />
        <div class="d-flex px-4 mt-4 text-center">
            Dear Customer, the <b class="display-contents">MAWB number</b> you have queried has not arrived and/or been
            invoiced by AGI Cargo. You may start a new search, or click continue to subscribe to an email alert when
            your cargo is available, or to enroll in AutoPay.
        </div>
        <div class="mt-5">
            <button matButton="outlined" appMatStrokedButtonBorder mat-dialog-close color="primary" class="me-2">
                NEW SEARCH
            </button>
            <button matButton="filled" type="submit" color="primary" (click)="continue()">CONTINUE</button>
        </div>
    </div>
</div>
